import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import { selectParsingRulesListItems } from "../../../../../../redux/parsing-rules/selector";
import { parsingRules } from "../../../../../../redux/parsing-rules/action";
import PageLoader from "../../../../../../components/PageLoader";
import Table from "../../../../../../common/components/table";
import { useNavigate } from "react-router-dom";

const ManagementParsingRules = () => {
	const dispatch = useAppDispatch()
  const [pageData, setPageData] = useState(1)
  const navigate = useNavigate()
    const itemsData = useSelector(selectParsingRulesListItems)
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
          { field: 'Name', headerName: 'Name',isEdit: true },
      { field: 'OwnerType', headerName: 'Owner Type' },
      { field: 'Options.InputFileType', headerName: 'InputFileType' },
      { field: 'Options.OutputFileType', headerName: 'OutputFileType' }
      
        ]);
      }
      const handleAdd=()=>{
        navigate(`${0}`)
      }
      const handleConvertFile=()=>{
        navigate(`/management/system/service/convert-file`)
      }
      const handleEdit=(data: any)=>{
        
        navigate(`${data?.Id}`)
      }
      
      const handleDelete=(data: any)=>{
        dispatch(parsingRules.delete({
          url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/system/service/parsing-rules/delete`,
          entity: 'parsingRules',
          jsonData: {
              Records: [
                  {
                      Id: data?.Id
                  }
              ]
          }
      })).then(() => {
          dispatch(parsingRules.list({
              url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/system/service/parsing-rules/list`,
              entity: 'parsingRules',
              jsonData: { "PageNumber": pageData,
              "PageSize": 10,
              "SortField": "Id",
              "SortOrder": "desc",}
          }));
      });
      }
      const additionButtons: any = [
        {
          name: 'Add Parsing Rule',
          callback: () => handleAdd(),
        },
        {
          name: 'Convert File',
          callback: () => handleConvertFile(),
        }
      ];
      const fetchParsingRules=()=>{
        dispatch(parsingRules.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/system/service/parsing-rules/list`,entity:'parsingRules',jsonData:{
      
        "PageNumber": pageData,
        "PageSize": 10,
        "SortField": "Id",
        "SortOrder": "desc",
        
    
        }}))
      }
	useEffect(() => {
        createColumnDefs()
        fetchParsingRules()
	}, [pageData])

	return (
    <>
    {itemsData?.isLoading ? <PageLoader />
 : 
		<Table columnData={columnDefs} rowData={itemsData?.result?.items} setPageData={setPageData}
    paginationData={itemsData?.result?.pagination}  onEdit={handleEdit} onDelete={handleDelete} additionButtons={additionButtons} headingName="Parsing Rules"/>
     
  }
  </>
	);
};

export default ManagementParsingRules;


